import { AlertTriangle } from 'lucide-react';
import { POS_Z_CLASS } from '../../utils/posZLayers';

/**
 * Confirmation POS (remplace window.confirm) — au-dessus des modales métier.
 */
export default function CaisseConfirmModal({
  open,
  title,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  variant,
  processing,
  testIdConfirm,
  testIdCancel,
}) {
  if (!open) return null;
  const btnClass =
    variant === 'danger'
      ? 'bg-red-600 hover:bg-red-700 text-white'
      : 'bg-emerald-600 hover:bg-emerald-700 text-white';
  return (
    <div
      className={`fixed inset-0 ${POS_Z_CLASS.modalConfirm} flex items-end sm:items-center justify-center bg-black/50 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]`}
      role="presentation"
      onClick={onCancel}
      data-testid="caisse-confirm-modal-backdrop"
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[min(90dvh,calc(100dvh-2rem))] flex flex-col overflow-hidden"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        data-testid="caisse-confirm-modal"
      >
        <div className="shrink-0 px-6 py-5 border-b border-slate-100">
          <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2">
            {variant === 'danger' && <AlertTriangle className="h-5 w-5 text-red-500" aria-hidden />}
            {title}
          </h3>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-5">{children}</div>
        <div className="shrink-0 px-6 py-4 border-t border-slate-100 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="min-h-[48px] px-5 py-2.5 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200"
            data-testid={testIdCancel || 'caisse-confirm-cancel'}
          >
            {cancelLabel || 'Annuler'}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={processing}
            className={`min-h-[48px] px-5 py-2.5 rounded-xl font-semibold disabled:opacity-50 ${btnClass}`}
            data-testid={testIdConfirm || 'caisse-confirm-ok'}
          >
            {confirmLabel || 'Confirmer'}
          </button>
        </div>
      </div>
    </div>
  );
}
